export interface Episode {
  id: string;
  ep: number;
  title: string;
  cover: string;
  airDate: string;
  status: string;
  duration: string;
  views: string;
  summary: string;
  highlights: string[];
}

export const episodes: Episode[] = [
  {
    id: "ep-1",
    ep: 1,
    title: "初为人母",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20mother%20holding%20her%20newborn%20baby%20in%20a%20softly%20lit%20modern%20bedroom%2C%20warm%20amber%20window%20light%2C%20shallow%20depth%20of%20field%2C%20muted%20teal%20and%20warm%20orange%20color%20grading%2C%20intimate%20emotional%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-01&orientation=landscape",
    airDate: "2025-08-12",
    status: "已完结",
    duration: "45 分钟",
    views: "186.4 万",
    summary:
      "故事从林晓在产房外的第一声啼哭开始。二十六岁的她刚结束职场冲刺，转身成为新手妈妈，喜悦与慌乱同时涌来。婆婆张桂兰的到来，让这个原本安静的小家第一次出现了微妙的裂痕。",
    highlights: ["林晓产后第一天的手忙脚乱", "婆婆入住带来的生活观念碰撞", "丈夫陈默在两人之间的左右为难"],
  },
  {
    id: "ep-2",
    ep: 2,
    title: "月子里的分寸",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20Chinese%20family%20gathering%20around%20a%20dining%20table%20in%20a%20warm%20apartment%2C%20grandmother%20serving%20soup%20to%20a%20tired%20young%20woman%2C%20golden%20afternoon%20light%20through%20curtains%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20quiet%20tension%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-02&orientation=landscape",
    airDate: "2025-08-13",
    status: "已完结",
    duration: "44 分钟",
    views: "172.8 万",
    summary:
      "坐月子的三十天，成了林晓真正意义上的成人礼。婆婆坚持的老规矩与她信的科学育儿不断冲突，而陈默白天上班、夜里补觉，几乎缺席了所有争吵的现场。",
    highlights: ["第一场关于育儿方式的正面冲突", "林晓偷偷查资料到凌晨", "陈默的一句‘你就听妈的’成为导火索"],
  },
  {
    id: "ep-3",
    ep: 3,
    title: "重返职场",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20woman%20in%20a%20smart%20blazer%20walking%20through%20a%20glass%20office%20lobby%2C%20reflections%20and%20cool%20daylight%2C%20muted%20teal%20with%20warm%20orange%20accents%2C%20determined%20yet%20anxious%20mood%2C%20editorial%20cinematography%2C%20high%20detail%2C%20clean%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-03&orientation=landscape",
    airDate: "2025-08-14",
    status: "已完结",
    duration: "46 分钟",
    views: "165.1 万",
    summary:
      "产假结束的第一个工作日，林晓在会议室和母婴室之间来回奔波。曾经属于她的项目已经换了负责人，同事的问候里带着礼貌的距离感，她第一次意识到自己正在被无声地推到场外。",
    highlights: ["林晓发现项目被他人接手", "挤奶间里的无声崩溃", "与苏雅重逢，闺蜜线开启"],
  },
  {
    id: "ep-4",
    ep: 4,
    title: "婆媳之间",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20two%20Chinese%20women%20of%20different%20generations%20standing%20across%20a%20narrow%20kitchen%2C%20one%20holding%20a%20bowl%2C%20tension%20in%20their%20posture%2C%20soft%20overcast%20light%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20restrained%20emotional%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-04&orientation=landscape",
    airDate: "2025-08-15",
    status: "已完结",
    duration: "45 分钟",
    views: "198.7 万",
    summary:
      "一锅没喝完的鲫鱼汤，引爆了积压已久的情绪。张桂兰诉说自己半生的辛苦，林晓则第一次把“这是我的孩子”说出了口。陈默夹在中间，终于做了一次并不漂亮的选择。",
    highlights: ["厨房里的摊牌", "张桂兰的过往被揭开", "陈默第一次公开支持林晓"],
  },
  {
    id: "ep-5",
    ep: 5,
    title: "闺蜜的婚礼",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20bright%20outdoor%20wedding%20reception%20with%20warm%20string%20lights%2C%20two%20young%20Chinese%20women%20laughing%20together%20amid%20guests%2C%20golden%20hour%20sunlight%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20joyful%20but%20bittersweet%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-05&orientation=landscape",
    airDate: "2025-08-18",
    status: "已完结",
    duration: "43 分钟",
    views: "154.3 万",
    summary:
      "苏雅的婚礼让林晓久违地喘了口气。可当伴娘致辞结束、灯光暗下来，她独自坐在角落刷着幼儿园家长群的消息，才发觉自己与曾经的世界已经隔了很远。",
    highlights: ["林晓与苏雅的深夜长谈", "关于‘成为自己’的追问", "林晓第一次萌生辞职念头"],
  },
  {
    id: "ep-6",
    ep: 6,
    title: "崩溃的夜",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20mother%20sitting%20alone%20on%20a%20dark%20apartment%20floor%20beside%20a%20crib%2C%20blue%20night%20light%20from%20a%20window%2C%20single%20warm%20lamp%2C%20muted%20teal%20with%20faint%20orange%20glow%2C%20exhausted%20lonely%20mood%2C%20editorial%20cinematography%2C%20high%20detail%2C%20dark%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-06&orientation=landscape",
    airDate: "2025-08-19",
    status: "已完结",
    duration: "47 分钟",
    views: "221.6 万",
    summary:
      "孩子连续第三个夜晚发烧。林晓一个人在急诊走廊排到凌晨三点，手机里给陈默的消息始终没有回复。这一夜之后，她不再指望任何人来拯救自己。",
    highlights: ["深夜急诊的孤立无援", "林晓独自处理孩子高烧", "她做出改变的第一步决定"],
  },
  {
    id: "ep-7",
    ep: 7,
    title: "重新出发",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20woman%20sketching%20designs%20at%20a%20sunlit%20cafe%20table%20with%20a%20laptop%20and%20coffee%2C%20morning%20sun%20through%20large%20windows%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20hopeful%20quiet%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-07&orientation=landscape",
    airDate: "2025-08-20",
    status: "已完结",
    duration: "44 分钟",
    views: "167.9 万",
    summary:
      "辞职后的林晓没有回到原来的轨道，而是捡起了大学时代的设计稿。苏雅递来一个自由职业的邀约，让她在厨房和书桌之间，重新拼出属于自己的时间。",
    highlights: ["林晓重启设计梦想", "第一次独立接单的忐忑", "陈默发现妻子的改变"],
  },
  {
    id: "ep-8",
    ep: 8,
    title: "母亲的秘密",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20an%20older%20Chinese%20woman%20looking%20through%20an%20old%20photo%20album%20in%20a%20dim%20living%20room%2C%20warm%20lamp%20glow%20and%20soft%20shadows%2C%20muted%20teal%20with%20warm%20orange%20accents%2C%20nostalgic%20revealing%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-08&orientation=landscape",
    airDate: "2025-08-21",
    status: "已完结",
    duration: "45 分钟",
    views: "189.2 万",
    summary:
      "张桂兰的一场小病，让林晓无意中翻开了一本旧相册。原来那个总是强势的婆婆，也曾是被生活推到墙角、独自撑起一个家的年轻母亲。两种母亲的人生，在这一集重叠。",
    highlights: ["旧相册揭开婆婆的过去", "婆媳第一次真正意义上的和解", "两代女性命运的呼应"],
  },
  {
    id: "ep-9",
    ep: 9,
    title: "裂缝与修补",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20couple%20sitting%20apart%20on%20a%20sofa%20in%20a%20quiet%20evening%20apartment%2C%20soft%20warm%20lamplight%2C%20distance%20and%20hesitation%20in%20their%20posture%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20melancholic%20hopeful%20mood%2C%20editorial%20cinematography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-09&orientation=landscape",
    airDate: "2025-08-22",
    status: "已完结",
    duration: "46 分钟",
    views: "176.5 万",
    summary:
      "陈默终于开始学着分担，却总是笨拙地踩错节奏。一次关于钱的争吵，把两人推到婚姻的悬崖边。他们没有立刻和好，而是坐下来，第一次谈了很久很久。",
    highlights: ["陈默笨拙的弥补", "婚姻危机被摆上台面", "两人深夜的长谈"],
  },
  {
    id: "ep-10",
    ep: 10,
    title: "孩子的第一步",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20toddler%20taking%20first%20steps%20toward%20a%20young%20Chinese%20mother%20kneeling%20on%20a%20living%20room%20rug%2C%20bright%20soft%20daylight%2C%20warm%20familial%20atmosphere%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20tender%20joyful%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-10&orientation=landscape",
    airDate: "2025-08-25",
    status: "已完结",
    duration: "43 分钟",
    views: "204.8 万",
    summary:
      "女儿迈出人生第一步的那天，林晓正在赶一份设计稿。她放下电脑跑过去的瞬间，忽然明白，所谓成长，从来不是只有孩子一个人的事。",
    highlights: ["孩子迈出第一步", "林晓事业与家庭的重新平衡", "全家第一次真正同桌吃饭"],
  },
  {
    id: "ep-11",
    ep: 11,
    title: "风暴来临",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20rainy%20city%20street%20at%20dusk%20with%20a%20young%20Chinese%20woman%20holding%20an%20umbrella%20hurrying%20past%20reflective%20windows%2C%20cool%20blue%20rain%20light%20with%20warm%20orange%20street%20lamps%2C%20tense%20determined%20mood%2C%20editorial%20cinematography%2C%20high%20detail%2C%20moody%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-11&orientation=landscape",
    airDate: "2025-08-26",
    status: "已完结",
    duration: "48 分钟",
    views: "233.4 万",
    summary:
      "自由职业的第一个大项目出了纰漏，合作方临时变卦。与此同时，陈默的公司面临裁员。风雨同时压下来的这一集，是全剧冲突最密集的一次。",
    highlights: ["林晓项目危机", "陈默面临失业", "两人第一次并肩面对难题"],
  },
  {
    id: "ep-12",
    ep: 12,
    title: "年轻的母亲",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20television%20drama%20still%20of%20a%20young%20Chinese%20mother%20and%20her%20daughter%20silhouetted%20against%20a%20bright%20window%20at%20sunrise%2C%20golden%20warm%20light%20flooding%20the%20room%2C%20muted%20teal%20and%20warm%20orange%20grading%2C%20hopeful%20uplifting%20mood%2C%20editorial%20film%20photography%2C%20high%20detail%2C%20warm%20neutral%20background&width=800&height=450&seq=nm1-ep-cover-12&orientation=landscape",
    airDate: "2025-08-27",
    status: "已完结",
    duration: "52 分钟",
    views: "268.1 万",
    summary:
      "所有线索在这一集汇合。林晓没有成为谁口中的完美母亲，而是学会了在自己和孩子之间划出健康的边界。婆婆回了老家，又常常打电话来；陈默换了工作，学会了做饭。日子没有变轻松，但她终于抬头看见了光。",
    highlights: ["林晓与自己和解", "婆媳关系走向平静", "开放式结局与第二季伏笔"],
  },
];